import { Rest } from 'utilities/rest';
import * as ActionCreator from 'utilities/action.creator';
import { $processing } from 'services/activity/action';
import { $done } from 'services/activity/action';

export const MODULE = 'Tracking';

const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, 'reset', () =>
  $reset.action()
);

export const $global = ActionCreator.Async(MODULE, 'Global', (payload) => {
  return async (dispatch) => {
    dispatch($processing($global.OPERATION));

    return await Rest.GET(`${API_URL}/tracking`, payload)
      .then((response) => {
        dispatch($global.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($global.OPERATION)));
  };
});

export const $shipment = ActionCreator.Async(MODULE, 'Shipment', (id, payload) => {
  return async (dispatch) => {
    dispatch($processing($shipment.OPERATION));

    return await Rest.GET(`${API_URL}/tracking/${id}/shipment`, payload)
      .then((response) => {
        dispatch($shipment.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($shipment.OPERATION)));
  };
});

export const $order = ActionCreator.Async(MODULE, 'Order', (id) => {
  return async (dispatch) => {
    dispatch($processing($order.OPERATION));

    return await Rest.GET(`${API_URL}/tracking/${id}/order`)
      .then((response) => {
        dispatch($order.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($order.OPERATION)));
  };
});

export const $manifest = ActionCreator.Async(MODULE, 'Manifest', (id) => {
  return async (dispatch) => {
    dispatch($processing($manifest.OPERATION));

    return await Rest.GET(`${API_URL}/tracking/${id}/manifest`)
      .then((response) => {
        dispatch($manifest.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($manifest.OPERATION)));
  };
});
